<template>
  <div>
     <el-dialog
         title="绑定手机号码列表"
         center
         width="500px"
         @open='getPhonel'
         @close='getTelList'
         :visible='listState'
         >
       <div v-if='!telList.length' style='text-align: center;'>暂无数据，请先绑定手机号</div>
       <div v-else>
           <ul class='list'>
               <li v-for='(item,i) in telList' :key='i'>
                   手机号：{{item}} <el-button type="danger" plain style='margin-left: 15px;' @click='delTel(item)'>解绑</el-button>
               </li>
           </ul>
       </div>
     </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "BindPhone",
    props: {
      listState: Boolean
    },
    data () {
      return {
        token: "",
        telList: []
      }
    },
    methods: {
      getPhonel () {
        // 先获取token
        this.token = JSON.parse(window.sessionStorage.getItem('authinfo')).token;
        this.$http.get('mm/bind/list',{
          params: {
            token: this.token
          }
        }).then(rel => {
          if (rel.data.code =='OK') {
            this.telList = rel.data.data
          }
        })
      },
      getTelList () {
        this.$emit('closeTelList',false)
      },
      // 删除手机号
      delTel (tel) {
        this.$confirm('解绑手机号, 是否继续?',"解绑手机号", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get('mm/unbind',{
            params: {
              token: this.token,
              phone: tel
            }
          }).then(rel => {
            if (rel.data.code == 'OK') {
              this.$message({
                type: 'success',
                message: rel.data.msg
              });
              this.getPhonel();
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    }

  }
</script>

<style scoped>
.list {
    font-size: 18px;
}
.list li {
    margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/BindPhone.vue